<template>
    <div class="card mb-3 table-card">
        <div class="card-header">
            <div class="row">
                <div class="col-lg-6 col-12">
                    <h3 class="mt-2">Channels ({{ filtered_asset_types.length }})</h3>
                </div>
                
                <div class="col-lg-6 d-none d-lg-block">
                    <div class="d-flex justify-content-end justify-self-end gap-2">
                        <a v-if="filtered_asset_types.length > 0" class="btn btn-primary float-end" href="/admin/asset_type/new">
                            <i class="fa fas fa-fw fa-plus"></i> Add Channel
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body p-0">
            <table class="table table-without-pagination mb-0">
                <thead>
                    <tr class="table-header-row">
                        <th @click="sortByKey('name')" class="d-table-cell">
                            <div class="d-flex flex-row">
                                Name
                                <div class="d-flex flex-column">
                                    <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'name' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="">
                                    <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'name' && sort_order === 'des') ? 'sort-key-active' : ''" alt="">
                                </div>
                            </div>
                        </th>
                        <th class="d-table-cell column-sort-disabled">
                            <div class="d-flex flex-row">
                                Icon
                            </div>
                        </th>
                        <th @click="sortByKey('inputs_length')" class="d-table-cell">
                            <div class="d-flex flex-row">
                                # of Input Fields
                                <div class="d-flex flex-column">
                                    <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'inputs_length' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="">
                                    <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'inputs_length' && sort_order === 'des') ? 'sort-key-active' : ''" alt="">
                                </div>
                            </div>
                        </th>
                
                        <th @click="sortByKey('updated_at')" class="d-table-cell">
                            <div class="d-flex flex-row">
                                Updated At
                                <div class="d-flex flex-column">
                                    <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'updated_at' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="">
                                    <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'updated_at' && sort_order === 'des') ? 'sort-key-active' : ''" alt="">
                                </div>
                            </div>
                        </th>
                        <th class="d-table-cell pe-3" width="1">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(asset_type, index) in filtered_asset_types" :key="asset_type.id" :class="`table-row-${index + 1}`">
                        <td class="d-table-cell align-start">
                            <a :href="'/admin/asset_type/' + asset_type.id">{{ asset_type.name }}</a>
                        </td>
                        <td class="d-table-cell">
                            <img :src="'/img/icons/avid-icons/' + asset_type.icon_class + '.svg'" class="asset-type-icon icon" alt=""></img>
                        </td>
                        <td class="d-table-cell">
                            {{ asset_type.inputs.length }}
                        </td>
                        <td class="d-table-cell">
                            {{ datetime(asset_type.updated_at) }}
                        </td>
                        <td class="d-table-cell">
                            <a href="#" class="btn btn-none" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete Asset Type" @click="deleteAssetType(asset_type)">
                                <img class="icon red-icon" src="/img/icons/avid-icons/trash.svg" alt="">
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { useNotifications } from '../../../composables/useNotifications';

export default {
    name: 'AssetTypeList',
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    props: {
        asset_types: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            filtered_asset_types: [],
            sort_key: 'name',
            sort_order: 'asc',
        }
    },
    beforeMount() {
        this.filtered_asset_types = [...this.asset_types]
    },
    methods: {
        sortByKey(key) {
            if (this.sort_key === key) {
                this.sort_order = (this.sort_order === 'asc') ? 'des' : 'asc'
            } else {
                this.sort_key = key
                this.sort_order = 'asc'
            }
            this.sortData()
        },
        sortData() {
            if(this.sort_key == 'inputs_length'){
                if (this.sort_order === 'asc') {
                    this.filtered_asset_types.sort((a, b) => a.inputs.length - b.inputs.length)
                } else {
                    this.filtered_asset_types.sort((a, b) => b.inputs.length - a.inputs.length)
                }        
            } else {
                if (this.sort_order === 'asc') {
                    this.filtered_asset_types.sort((a, b) => a[this.sort_key].localeCompare(b[this.sort_key]))
                } else {
                    this.filtered_asset_types.sort((a, b) => b[this.sort_key].localeCompare(a[this.sort_key]))
                }
            }
        },
        deleteAssetType(asset_type) {
            Swal.fire({
                title: "Are you sure you want to delete this channel?",
                text: "This channel will be removed from all associated Plays and Templates.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete",
                customClass: {
                    popup: 'swal-warning'
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    window.axios.delete('/api/playbooks/asset_type/'+ asset_type.id)
                    this.showNotification({
                        text: '<strong>' + asset_type.name + '</strong> was deleted!'
                    })
                    for(var i = 0; i < this.filtered_asset_types.length; i++){
                        if(this.filtered_asset_types[i].id == asset_type.id){
                            this.filtered_asset_types.splice(i, 1)
                            break
                        }
                    }
                }
            })
        }
    }
}
</script>

